import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type EmptyStateProps = {
  title: string;
  message: React.ReactNode;
  className?: string;
};

export function EmptyState({ className = 'empty', message, title }: EmptyStateProps) {
  return (
    <Box className={className}>
      <Typography component="h3" variant="h3">{title}</Typography>
      <Typography component="p">{message}</Typography>
    </Box>
  );
}
